import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import {
  $insertNodes, COMMAND_PRIORITY_EDITOR, createCommand,
} from 'lexical';
import { useEffect } from 'react';
import { $createFormulaNode, FormulaNode } from './FormulaNode';

export const INSERT_FORMULA_COMMAND = createCommand<void>();

export default function FormulaNodePlugin(): JSX.Element | null {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    if (!editor.hasNodes([FormulaNode])) {
      throw new Error('FormulaNodePlugin: FormulaNodeNode not registered on editor');
    }

    return editor.registerCommand<string>(
      INSERT_FORMULA_COMMAND,
      () => {
        const formulaNode = $createFormulaNode();
        $insertNodes([formulaNode]);

        return true;
      },
      COMMAND_PRIORITY_EDITOR,
    );
  }, [editor]);

  return null;
}
